import * as NS from './namespace';
import { IIndicator, ISensorDevice } from '@/model/meta';
import { IIndicatorValue } from '@/model/datamart';

const getters: NS.IViewingGetters = {
    getPreloader(state: NS.IViewingState): boolean {
        return state.preloader;
    },
    getFailLoading(state: NS.IViewingState): boolean {
        return state.failLoading;
    },
    getActiveFormRequest(state: NS.IViewingState): boolean {
        return state.activeFormRequest;
    },
    getFailedFormRequest(state: NS.IViewingState): boolean {
        return state.failedFormRequest;
    },
    getActiveDevices(state: NS.IViewingState): ISensorDevice[] {
        return state.activeDevices;
    },
    getAbailableIndicators(state: NS.IViewingState): IIndicator[] {
        return state.abailableIndicators;
    },
    getIndictorValuesGrid(state: NS.IViewingState): IIndicatorValue[] {
        return state.indictorValuesGrid;
    },
    getIndictorValuesGrids(state: NS.IViewingState): { [key: string]: IIndicatorValue[] } {
        return state.indictorValuesGrids;
    },
    getActiveUploadRequest(state: NS.IViewingState): boolean {
        return state.activeUploadRequest;
    },
    getFailedUploadRequest(state: NS.IViewingState): boolean {
        return state.failedUploadRequest;
    },
    getsSuccessUploadRequest(state: NS.IViewingState): boolean {
        return state.successUploadRequest;
    },
};

/** Реализация геттеров модуля просмотра */
export default getters;